import { clsx } from 'clsx';

function inputClassNameBase({
  size = 'auto'
} = {}) {
  return clsx('form-control',
  // TODO: Deprecate
  'np-form-control', {
    'np-form-control--size-auto': size === 'auto',
    'np-form-control--size-sm': size === 'sm',
    'np-form-control--size-md': size === 'md',
    'np-form-control--size-lg': size === 'lg'
  });
}

export { inputClassNameBase };
//# sourceMappingURL=_common.mjs.map
